import { Component, OnInit, Input, Output, EventEmitter, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { IonCheckbox } from '@ionic/angular';

@Component({
    selector: 'c-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent<T = any> implements OnInit, ControlValueAccessor {
  @Input() checked: boolean;
  @Input() disabled: boolean;
  @Input() name = '';
  @Input() text = '';
  @Input() subtitle: string;
  @Input() value: string | undefined;
  @Input() showError = true;

  @Output() action: EventEmitter<any> = new EventEmitter();

  @ViewChild('checkbox') checkbox: IonCheckbox | undefined;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get control() {
    return this.ngControl?.control as FormControl;
  }

  ngOnInit(): void {}

  writeValue(value: any): void {}

  onCheckedChange = () => {
    this.control.setValue(this.checkbox.checked);
  };

  onChange = (value: T) => {};
  onTouched = () => {};

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
}
